// /managers/DragDropManager.jsx
import { useState, useEffect } from 'react';

class DragDropManager {
  subscribers = new Set();
  state = {
    activeDropZone: null,
    modalOpen: false,
    dragCounter: 0,
    pinnedConstantsOpen: false
  };

  // --- FIX: All methods are converted to arrow functions ---
  // This lexically binds `this`, permanently fixing context issues.
  setState = (newState) => {
    this.state = { ...this.state, ...newState };
    this.notifySubscribers();
  };

  getState = () => {
    return this.state;
  };

  subscribe = (callback) => {
    this.subscribers.add(callback);
    return () => this.subscribers.delete(callback);
  };

  notifySubscribers = () => {
    this.subscribers.forEach(cb => cb(this.state));
  };

  setModalOpen = (isOpen) => {
    this.setState({ modalOpen: isOpen });
  };

  setPinnedConstantsOpen = (isOpen) => {
    this.setState({ pinnedConstantsOpen: isOpen });
  };

  setActiveDropZone = (zoneId) => {
    this.setState({ activeDropZone: zoneId });
  };

  incrementDragCounter = () => {
    if (!this.state.pinnedConstantsOpen) {
      this.setState({ dragCounter: this.state.dragCounter + 1 });
    }
  };

  decrementDragCounter = () => {
    if (!this.state.pinnedConstantsOpen) {
      this.setState({ dragCounter: Math.max(0, this.state.dragCounter - 1) });
    }
  };

  resetDragCounter = () => {
    this.setState({ dragCounter: 0 });
  };
}
//SHELBYPIN: 5777
export const dragDropManager = new DragDropManager();

// React hook to use the manager
export const useDragDrop = () => {
  const [state, setState] = useState(dragDropManager.getState());

  useEffect(() => {
    // Directly subscribing the setState function is clean and safe.
    const unsubscribe = dragDropManager.subscribe(setState);
    return unsubscribe;
  }, []);

  // --- FIX: Return the manager's methods directly ---
  // Since they are now stable arrow functions on a singleton, 
  // we don't need useCallback and they won't cause re-renders.
  return {
    ...state,
    setModalOpen: dragDropManager.setModalOpen,
    setActiveDropZone: dragDropManager.setActiveDropZone,
    setPinnedConstantsOpen: dragDropManager.setPinnedConstantsOpen,
    resetDragCounter: dragDropManager.resetDragCounter,
    incrementDragCounter: dragDropManager.incrementDragCounter,
    decrementDragCounter: dragDropManager.decrementDragCounter
  };
};